import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var StoreLink = function StoreLink(_ref) {
  var link = _ref.link,
    imgSrc = _ref.imgSrc,
    ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/React.createElement("a", {
    "aria-label": ariaLabel || 'ссылка на магазин приложений',
    className: cx('icon-wrap'),
    href: link,
    rel: "noreferrer",
    target: "_blank",
    "data-t-id": "components-StoreLink"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: imgSrc
  }));
};
StoreLink.propTypes = process.env.NODE_ENV !== "production" ? {
  imgSrc: PropTypes.string,
  link: PropTypes.string
} : {};